<template lang="html">

  <section class="mass-adjustment">
    <div class="pageHeading">
      <h1>Mass Adjustment</h1>
    </div>
<add-fundraising v-bind:massAdjustment="true" v-on:alertUser="(result, message) => {this.$emit('alertUser', result, message);}"></add-fundraising>


  </section>

</template>

<script lang="js">
    import addFundraising from '../components/AddFundraising'
  export default  {
    name: 'massadjustment',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
      components: {
          addFundraising
      },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">

</style>
